import { Link } from "react-router-dom";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="relative z-10 border-t border-[#E7E5E4] mt-24 bg-[#F2F0EB]"
  >
    <div className="max-w-6xl mx-auto px-6 md:px-10 py-14 flex flex-col md:flex-row justify-between gap-8">
      <div>
        <p className="font-display text-2xl tracking-tight text-[#1C1917]">
          Il Cassetto delle <span className="italic text-[#9F583F]">Giraffe</span>
        </p>
        <p className="font-body text-sm text-[#57534E] mt-2 max-w-xs leading-relaxed">
          Storie, idee e curiosità per guardare il mondo con occhi diversi.
        </p>
      </div>
      <div className="flex flex-col gap-3">
        <Link to="/" className="label-ui text-[#57534E] hover:text-[#9F583F] transition-colors">
          Articoli
        </Link>
        <Link to="/chi-sono" className="label-ui text-[#57534E] hover:text-[#9F583F] transition-colors">
          Chi sono
        </Link>
        <Link to="/sponsor" className="label-ui text-[#57534E] hover:text-[#9F583F] transition-colors">
          Sponsor
        </Link>
        <Link to="/contatti" className="label-ui text-[#57534E] hover:text-[#9F583F] transition-colors">
          Contatti
        </Link>
        <Link to="/accedi" className="label-ui text-[#57534E] hover:text-[#9F583F] transition-colors" data-testid="footer-admin-link">
          Area autore
        </Link>
      </div>
    </div>
    <div className="border-t border-[#E7E5E4]">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="label-ui text-[#57534E]">
          © {new Date().getFullYear()} Fabio Campana — Tutti i diritti riservati
        </p>
        <div className="flex items-center gap-6">
          <Link to="/termini" className="label-ui text-[#57534E] hover:text-[#9F583F] transition-colors" data-testid="footer-terms-link">
            Termini e Condizioni
          </Link>
          <Link to="/privacy" className="label-ui text-[#57534E] hover:text-[#9F583F] transition-colors" data-testid="footer-privacy-link">
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  </footer>
);
